/* =========================================================
   Maga Patriot Shop — Theme JS
   Vanilla JS: mobile nav, search panel, cart drawer, AJAX cart,
   variant picker, quantity selector, accordions.
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {

  var overlay = document.querySelector('[data-overlay]');

  function openEl(el){ if(el){ el.classList.add('is-open'); } }
  function closeEl(el){ if(el){ el.classList.remove('is-open'); } }
  function toggleOverlay(state){
    if(!overlay) return;
    if(state){ overlay.classList.add('is-open'); } else { overlay.classList.remove('is-open'); }
  }

  /* ---------- Mobile nav ---------- */
  var mobileNav = document.querySelector('[data-mobile-nav]');
  document.querySelectorAll('[data-menu-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      openEl(mobileNav);
      toggleOverlay(true);
    });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function(btn){
    btn.addEventListener('click', function(){
      closeEl(mobileNav);
      if(!isDrawerOpen()) toggleOverlay(false);
    });
  });

  /* ---------- Search panel ---------- */
  var searchPanel = document.querySelector('[data-search-panel]');
  document.querySelectorAll('[data-search-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(){
      searchPanel.classList.toggle('is-open');
      if(searchPanel.classList.contains('is-open')){
        var input = searchPanel.querySelector('input[type="search"]');
        if(input) input.focus();
      }
    });
  });

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  function isDrawerOpen(){ return cartDrawer && cartDrawer.classList.contains('is-open'); }

  function openCartDrawer(){
    if(!cartDrawer) return;
    openEl(cartDrawer);
    toggleOverlay(true);
  }
  function closeCartDrawer(){
    closeEl(cartDrawer);
    if(!mobileNav || !mobileNav.classList.contains('is-open')) toggleOverlay(false);
  }
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      if (cartDrawer) { openCartDrawer(); refreshCartDrawer(); }
      else { window.location.href = '/cart'; }
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(btn){
    btn.addEventListener('click', closeCartDrawer);
  });
  if(overlay){
    overlay.addEventListener('click', function(){
      closeEl(mobileNav); closeEl(cartDrawer); closeEl(searchPanel); toggleOverlay(false);
    });
  }

  function money(cents, format){
    var value = (cents / 100).toFixed(2);
    return (format || '${{amount}}').replace('{{amount}}', value);
  }

  function renderCartDrawer(cart){
    if(!cartDrawer) return;
    var itemsWrap = cartDrawer.querySelector('[data-cart-items]');
    var footer = cartDrawer.querySelector('[data-cart-footer]');
    var countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach(function(el){ el.textContent = cart.item_count; });

    if(cart.item_count === 0){
      itemsWrap.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all" class="btn btn--navy" data-cart-close>Continue Shopping</a></div>';
      if(footer) footer.style.display = 'none';
      return;
    }
    if(footer) footer.style.display = 'block';

    var html = '';
    cart.items.forEach(function(item){
      html += '<div class="cart-drawer__item" data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '"><img src="' + (item.image || '') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy"></a>' +
        '<div style="flex:1">' +
          '<div class="cart-drawer__item-title"><a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a></div>' +
          (item.variant_title ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
          '<div class="quantity-selector" data-key="' + item.key + '">' +
            '<button type="button" data-qty-decrease>−</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-qty-input>' +
            '<button type="button" data-qty-increase>+</button>' +
          '</div>' +
        '</div>' +
        '<div style="text-align:right"><div class="price">' + money(item.final_line_price) + '</div>' +
          '<button class="cart-drawer__item-remove" data-remove-key="' + item.key + '">Remove</button></div>' +
      '</div>';
    });
    itemsWrap.innerHTML = html;
    var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price);

    itemsWrap.querySelectorAll('[data-remove-key]').forEach(function(btn){
      btn.addEventListener('click', function(){ changeLine(btn.getAttribute('data-remove-key'), 0); });
    });
    itemsWrap.querySelectorAll('[data-qty-decrease]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var wrap = btn.closest('[data-key]');
        var input = wrap.querySelector('[data-qty-input]');
        var newQty = Math.max(0, parseInt(input.value || '1', 10) - 1);
        changeLine(wrap.getAttribute('data-key'), newQty);
      });
    });
    itemsWrap.querySelectorAll('[data-qty-increase]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var wrap = btn.closest('[data-key]');
        var input = wrap.querySelector('[data-qty-input]');
        var newQty = parseInt(input.value || '1', 10) + 1;
        changeLine(wrap.getAttribute('data-key'), newQty);
      });
    });
  }

  function escapeHtml(str){
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function refreshCartDrawer(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(renderCartDrawer);
  }

  function changeLine(key, quantity){
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function(r){ return r.json(); }).then(renderCartDrawer);
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-product-form]');
    if(!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: {'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(){
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
        refreshCartDrawer();
        openCartDrawer();
      })
      .catch(function(){
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
        form.submit();
      });
  });

  /* ---------- Quantity selector (product page) ---------- */
  document.querySelectorAll('[data-quantity-wrapper]').forEach(function(wrap){
    var input = wrap.querySelector('input');
    var dec = wrap.querySelector('[data-qty-decrease]');
    var inc = wrap.querySelector('[data-qty-increase]');
    if(dec) dec.addEventListener('click', function(){ input.value = Math.max(1, (parseInt(input.value,10)||1) - 1); });
    if(inc) inc.addEventListener('click', function(){ input.value = (parseInt(input.value,10)||1) + 1; });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function(form){
    var dataEl = form.querySelector('[data-product-json]');
    if(!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch(err){ return; }

    var optionInputs = form.querySelectorAll('[data-option-index]');
    var idInput = form.querySelector('[data-variant-id]');
    var priceEl = form.closest('.product__info, .product-card') ? form.parentElement.querySelector('[data-price]') : null;
    priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare-price]');
    var submitBtn = form.querySelector('[type="submit"]');
    var mainImage = document.querySelector('[data-main-image]');

    function getSelectedOptions(){
      var selections = [];
      optionInputs.forEach(function(input){
        if(input.type === 'radio'){
          if(input.checked) selections[parseInt(input.getAttribute('data-option-index'),10)] = input.value;
        } else {
          selections[parseInt(input.getAttribute('data-option-index'),10)] = input.value;
        }
      });
      return selections;
    }

    function findVariant(selections){
      return product.variants.find(function(v){
        return v.options.every(function(opt, i){ return opt === selections[i]; });
      });
    }

    function updateUI(){
      var selections = getSelectedOptions();
      var variant = findVariant(selections);

      form.querySelectorAll('.swatch').forEach(function(sw){
        var idx = parseInt(sw.getAttribute('data-option-index'), 10);
        var val = sw.getAttribute('data-value');
        var testSelections = selections.slice();
        testSelections[idx] = val;
        var match = findVariant(testSelections);
        sw.disabled = !match || !match.available;
        sw.classList.toggle('is-selected', selections[idx] === val);
      });

      if(variant){
        if(idInput) idInput.value = variant.id;
        if(priceEl) priceEl.textContent = money(variant.price, window.themeMoneyFormat);
        if(compareEl){
          if(variant.compare_at_price && variant.compare_at_price > variant.price){
            compareEl.textContent = money(variant.compare_at_price, window.themeMoneyFormat);
            compareEl.style.display = '';
          } else { compareEl.style.display = 'none'; }
        }
        if(submitBtn){
          submitBtn.disabled = !variant.available;
          submitBtn.textContent = variant.available ? submitBtn.getAttribute('data-add-text') : submitBtn.getAttribute('data-soldout-text');
        }
        if(mainImage && variant.featured_image){
          mainImage.src = variant.featured_image.src;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      } else if(submitBtn){
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.getAttribute('data-soldout-text');
      }
    }

    optionInputs.forEach(function(input){
      input.addEventListener('change', updateUI);
      if(input.type !== 'radio'){
        input.addEventListener('input', updateUI);
      }
    });
    form.querySelectorAll('.swatch').forEach(function(sw){
      sw.addEventListener('click', function(){
        var idx = sw.getAttribute('data-option-index');
        form.querySelectorAll('[data-option-index="'+idx+'"] input, [data-option-index="'+idx+'"].swatch').forEach(function(){});
        var radio = form.querySelector('input[data-option-index="'+idx+'"][value="'+CSS.escape(sw.getAttribute('data-value'))+'"]');
        if(radio){ radio.checked = true; }
        form.querySelectorAll('.swatch[data-option-index="'+idx+'"]').forEach(function(el){ el.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        updateUI();
      });
    });
    updateUI();
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var mainImage = document.querySelector('[data-main-image]');
      if(mainImage){ mainImage.src = thumb.getAttribute('data-full'); }
      document.querySelectorAll('[data-thumb]').forEach(function(t){ t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* ---------- Accordion ---------- */
  document.querySelectorAll('.accordion__trigger').forEach(function(trigger){
    trigger.addEventListener('click', function(){
      trigger.closest('.accordion__item').classList.toggle('is-open');
    });
  });

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if(sortSelect){
    sortSelect.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Cart page quantity change ---------- */
  document.querySelectorAll('[data-cart-page-qty]').forEach(function(input){
    input.addEventListener('change', function(){
      changeLine(input.getAttribute('data-key'), parseInt(input.value,10) || 0);
      setTimeout(function(){ window.location.reload(); }, 250);
    });
  });
  document.querySelectorAll('[data-cart-page-remove]').forEach(function(btn){
    btn.addEventListener('click', function(){
      changeLine(btn.getAttribute('data-key'), 0);
      setTimeout(function(){ window.location.reload(); }, 250);
    });
  });

  /* ---------- Header shadow on scroll ---------- */
  var siteHeader = document.querySelector('.site-header');
  if(siteHeader){
    var updateHeaderShadow = function(){
      if(window.scrollY > 8){ siteHeader.classList.add('is-scrolled'); }
      else{ siteHeader.classList.remove('is-scrolled'); }
    };
    updateHeaderShadow();
    window.addEventListener('scroll', updateHeaderShadow, { passive: true });
  }

  /* ---------- Scroll-reveal animations ---------- */
  var revealTargets = document.querySelectorAll('.reveal');
  if(revealTargets.length){
    if('IntersectionObserver' in window){
      var revealObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
      revealTargets.forEach(function(el){ revealObserver.observe(el); });
    } else {
      revealTargets.forEach(function(el){ el.classList.add('is-visible'); });
    }
  }

  /* Auto-stagger reveal delay within common grid/group containers */
  document.querySelectorAll('.category-grid, .product-grid, .trust-badges').forEach(function(group){
    var children = group.querySelectorAll(':scope > .reveal');
    children.forEach(function(el, i){
      el.style.setProperty('--reveal-delay', (Math.min(i, 6) * 0.08) + 's');
    });
  });
});
